<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div class="flex-container">
  <div class="inbox-new-message">
    <div class="inbox-new-message__header">
      <p>
        {{ 'INBOX.NEW_MESSAGE.NEW_MESSAGE_FROM' | translate }}:
        {{ companyName$ | async }}
      </p>
      <div class="inbox-new-message__close">
        <mat-icon (click)="close()">close</mat-icon>
      </div>
    </div>
    <inbox-select-contact
      ngDefaultControl
      [formControl]="selectControl"
      (suggestedChannel)="changeAvailableChannels($event)"
    ></inbox-select-contact>
  </div>
  <div *ngIf="!!disabledAlert(); else composer" class="alert-container">
    <glxy-alert
      type="tip"
      [showAction]="!!disabledAlert()?.action"
      [extendedBorder]="false"
      [actionTitle]="disabledAlert()?.action?.title ?? '' | translate"
      (actionClick)="disabledAlert()?.action?.callback()"
    >
      <strong>{{ disabledAlert()?.title ?? '' | translate }}</strong>
      <glxy-alert-extended>{{ disabledAlert()?.description ?? '' | translate }}</glxy-alert-extended>
    </glxy-alert>
  </div>
  <ng-template #composer>
    <ng-container *ngIf="channelsToShow$ | async as channelsToShow">
      <inbox-message-text
        class="inbox-message-text"
        [conversationDetail]="null"
        [availableChannels]="channelsToShow"
        (sendMessage)="onSubmitDraft($event)"
      ></inbox-message-text>
    </ng-container>
  </ng-template>
</div>
